var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-5"},[_c('v-data-table',{attrs:{"item-key":"id","items-per-page":5,"headers":_vm.headers,"items":_vm.checks,"loading-text":"Đang Tải","no-data-text":"Không có dữ liệu"},scopedSlots:_vm._u([{key:"item.type",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.type === 'refund' ? 'Hoàn trả' : 'Đối soát')+"\n    ")]}},{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm.formatDate(item.createdAt))+"\n    ")]}},{key:"item.currentAmount",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm.formatMoney(item.data.currentAmount || 0))+"\n    ")]}},{key:"item.uploader",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.uploader.name)+"\n    ")]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }